import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router';

const CHORD_TIMEOUT = 500;

const SHORTCUTS: Record<string, string> = {
  u: '/users',
  s: '/shops',
  b: '/subscriptions',
  p: '/plans',
  f: '/finance',
  a: '/announcements',
  d: '/admin',
};

export function useAdminKeyboardShortcuts() {
  const navigate = useNavigate();
  const location = useLocation();
  const pendingRef = useRef(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!location.pathname.startsWith('/admin')) return;

    function handleKeyDown(e: KeyboardEvent) {
      // Ignore when typing in inputs
      const target = e.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.tagName === 'SELECT' ||
        target.isContentEditable
      ) {
        return;
      }

      if (e.metaKey || e.ctrlKey || e.altKey) return;

      if (pendingRef.current) {
        pendingRef.current = false;
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          timerRef.current = null;
        }

        const route = SHORTCUTS[e.key];
        if (route) {
          e.preventDefault();
          navigate(route);
        }
        return;
      }

      if (e.key === 'g') {
        e.preventDefault();
        pendingRef.current = true;
        timerRef.current = setTimeout(() => {
          pendingRef.current = false;
        }, CHORD_TIMEOUT);
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [navigate, location.pathname]);
}
